import { TariffCodeSuggestion } from '~/lib/api/smartsend/types';
import { TariffCode } from './TariffCode';
import { GetTariffCodeFromSuggestion } from './GetTariffCodeFromSuggestion';
import { P2GText, P2GGrid, P2GBox } from '@parcel2go/core-ui';

interface props {
  suggestion: TariffCodeSuggestion;
  tariffSystem: string;
  title?: string;
  children?: React.ReactNode;
}

const TariffSuggestion: React.FC<props> = (props) => {
  return (
    <P2GBox p={1} bordered>
      <P2GText variant="body2">
        {props.title && (
          <>
            {props.title}
            <br />
          </>
        )}
        <strong>{props.suggestion.Name}</strong>
      </P2GText>
      <P2GBox pt={1}>
        <P2GGrid container alignItems="center" alignContent="center" spacing={2}>
          <P2GGrid item flexShrink={1}>
            <TariffCode code={GetTariffCodeFromSuggestion(props.tariffSystem, props.suggestion)} selectable />
          </P2GGrid>
          <P2GGrid item flexShrink={1}>
            {props.children}
          </P2GGrid>
        </P2GGrid>
      </P2GBox>
    </P2GBox>
  );
};

export { TariffSuggestion };
